import config from 'utils/config';

const assetRoot = config('assetRoot');

/**
 * Puts the S3 root URL in front of whatever string is provided.
 * @param src - The relative asset path.
 * @returns The absolute URL.
 */
const prependAssetRoot = (src: string): string =>
  // Don't prepend to an empty val
  src ? `${assetRoot}${src}` : src;

export default prependAssetRoot;
